<template>
    <el-row>
        <el-form :model="insuranceForm" :rules="rules" @onSelectInfo="onSelectInfo"
                 addAction="/lcwpInsurance/saveInsuranceOrder.action"
                 editAction="/lcwpInsurance/editInsuranceOrder.action"
                 label-width="150px"
                 ref="insuranceForm" selectAction="/lcwpInsurance/selectInsuranceOrder.action"
                 style="width:50%" v-form>
            <el-form-item label="姓名" prop="insuredName">
                <el-input placeholder="姓名" v-model="insuranceForm.insuredName"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="insuredPhone">
                <el-input placeholder="请输汽车网用户手机" v-model="insuranceForm.insuredPhone"></el-input>
            </el-form-item>
            <el-form-item label="保单号" prop="number">
                <el-input placeholder="保单号" v-model="insuranceForm.number"></el-input>
            </el-form-item>
            <el-form-item label="保险公司" prop="companyName">
                <el-input placeholder="保险公司" v-model="insuranceForm.companyName"></el-input>
            </el-form-item>
            <el-form-item label="保险金额元" prop="costs">
                <el-input placeholder="请输入" type="number" v-model="insuranceForm.costs"></el-input>
            </el-form-item>
            <el-form-item label="保险有效期" prop="effective">
                <el-date-picker
                        @change="onDateTimeRangeChange"
                        end-placeholder="保险有效截止日期"
                        range-separator="至"
                        start-placeholder="保险有效起始日期"
                        type="datetimerange"
                        v-model="insuranceForm.effectiveDate">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="上传保单照片" prop="image">
                <el-upload
                        list-type="picture-card"
                        multiple
                        :data="{floder:'insurance'}"
                        :http-request="onHttpRequest"

                        :file-list="insuranceForm.image"
                        action="upload/uploadPic"
                        class="avatar-uploader"
                        v-model="insuranceForm.image">
                    <i class="el-icon-plus"></i>
                </el-upload>
                <div style="color:#999;">支持jpg格式，750*500px，上限1张</div>
            </el-form-item>
            <el-form-item label="环保绿豆总奖励" prop="maxCount">
                <el-input placeholder="请输入" type="number" v-model="insuranceForm.maxCount"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary">确定</el-button>
                <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
        </el-form>
    </el-row>
</template>

<script>
import BasicPager from '@/mixins/BasicPager'

export default {
  extends: BasicPager,
  components: {},
  name: 'saveInsuranceOrder',
  data () {
    let validateLocalCarAccount = (rule, value, callback) => {
      let vl = value + ''
      let match = vl.match(/[\u4E00-\u9FA5]/)
      if (match) {
        callback(new Error('登录账号不能为汉字！'))
      }
      callback()
    }
    return {
      insuranceForm: {
        id: null,
        effectiveDate: [],
        image: null
      },
      rules: {
        insuredName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        insuredPhone: [
          { validator: validateLocalCarAccount, trigger: 'blur' }
        ],
        number: [
          { required: true, message: '请输入保单号', trigger: 'blur' }
        ],
        companyName: [
          { required: true, message: '请输入保险公司', trigger: 'blur' }
        ],
        costs: [
          { required: true, message: '请输入保险金额(元)', trigger: 'blur' }
        ],
        effectiveDate: [
          { type: 'date', required: true, message: '请选择保险有效时间', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.insuranceForm.id = this.$route.params.id
  },
  methods: {
    onFilterParams: function (params) {
      params.costs = parseInt(params.costs * 100)
    },
    onSelectInfo: function (dataInfo) {
      let params = dataInfo.datas
      this.insuranceForm.effectiveDate = [new Date(params.effectiveStartTime), new Date(params.effectiveEndTime)]
    },
    onDateTimeRangeChange: function (dateTimeRange) {
      if (!dateTimeRange) {
        this.insuranceForm.effectiveStartTime = null
        this.insuranceForm.effectiveEndTime = null
        return
      }

      if (dateTimeRange[0] && dateTimeRange[1]) {
        this.insuranceForm.effectiveStartTime = dateTimeRange[0].getTime()
        this.insuranceForm.effectiveEndTime = dateTimeRange[1].getTime()
      }

      this.$refs['table-template'].search()
    }
  }
}
</script>

<style scoped>

</style>
